import { useContext } from 'react';
import {
  ApplicationContext,
  ApplicationContextType,
} from '@/hooks/providers/useApplicationProvider';

const useApplication = (): ApplicationContextType =>
  useContext(ApplicationContext);

export default useApplication;
